/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomgueststopevents4Inputs */

const en_statsroomgueststopevents4 = /** @type {(inputs: Statsroomgueststopevents4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events with the most guests (30 days)`)
};

const de_statsroomgueststopevents4 = /** @type {(inputs: Statsroomgueststopevents4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events mit den meisten Gästen (30 Tage)`)
};

/**
* | output |
* | --- |
* | "Events with the most guests (30 days)" |
*
* @param {Statsroomgueststopevents4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomgueststopevents4 = /** @type {((inputs?: Statsroomgueststopevents4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomgueststopevents4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomgueststopevents4(inputs)
	return de_statsroomgueststopevents4(inputs)
});
export { statsroomgueststopevents4 as "statsRoomGuestsTopEvents" }